import { Link } from 'react-router-dom';
import type { Software } from '@/types/software';
import { formatDownloads, platformIcons } from '@/utils/catalog';

export default function SoftwareCard({ item }: { item: Software }) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative h-44 w-full overflow-hidden bg-secondary-100">
        <img
          src={item.cover}
          alt={`${item.name} ${item.enName} 影视播放软件下载`}
          title={`${item.name} - 看片软件下载`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded-md bg-primary-700/90 px-2 py-1 text-xs font-medium text-background-50">
          {item.type}
        </span>
        <span className="absolute right-3 top-3 flex items-center gap-1 rounded-md bg-background-50/90 px-2 py-1 text-xs font-semibold text-accent-700">
          <i className="ri-star-fill text-accent-500"></i>
          {item.rating.toFixed(1)}
        </span>
      </div>

      <div className="flex flex-1 flex-col p-4">
        <div className="mb-2 flex items-start justify-between gap-2">
          <div className="min-w-0">
            <h3 className="truncate text-base font-semibold text-foreground-900 group-hover:text-primary-600">
              {item.name}
            </h3>
            <p className="truncate text-xs text-foreground-400">{item.enName}</p>
          </div>
          <span className="shrink-0 rounded-md bg-background-100 px-2 py-1 text-xs font-medium text-foreground-600">
            {item.version}
          </span>
        </div>

        <p className="mb-3 line-clamp-2 text-sm leading-relaxed text-foreground-500">{item.summary}</p>

        <div className="mb-4 flex flex-wrap items-center gap-1.5">
          {item.platforms.map((p) => (
            <span
              key={p}
              className="flex items-center gap-1 rounded-md bg-secondary-100 px-2 py-1 text-xs text-secondary-800"
            >
              <i className={`${platformIcons[p]} text-xs`}></i>
              {p}
            </span>
          ))}
        </div>

        <div className="mt-auto flex items-center justify-between border-t border-background-200 pt-3">
          <span className="flex items-center gap-1 text-xs text-foreground-400">
            <i className="ri-download-2-line text-sm"></i>
            {formatDownloads(item.downloads)}次下载
          </span>
          <span className="flex items-center gap-1 whitespace-nowrap rounded-md bg-accent-500 px-3 py-1.5 text-xs font-medium text-foreground-950 transition-colors group-hover:bg-accent-600">
            <i className="ri-download-line text-sm"></i>
            查看下载
          </span>
        </div>
      </div>
    </Link>
  );
}